(function() {
	'use strict';

	console.log('[GIFT CARD] Step 1: Script loaded');

	if (!window.configGiftCard) {
		console.log('[GIFT CARD] Step 2: Configuration not found - window.configGiftCard is undefined');
		return;
	}
	console.log('[GIFT CARD] Step 2: Configuration found:', window.configGiftCard);

	if (!window.configGiftCard.enable) {
		console.log('[GIFT CARD] Step 3: Feature is disabled');
		return;
	}

	const isEnabled = window.configGiftCard.enable === 'true' || 
	                  window.configGiftCard.enable === true || 
	                  window.configGiftCard.enable === 'True';
	if (!isEnabled) {
		console.log('[GIFT CARD] Step 3: Feature is disabled (value:', window.configGiftCard.enable, ')');
		return;
	}
	console.log('[GIFT CARD] Step 3: Feature is ENABLED');

	const GIFT_CARD_VARIANT_ID = window.configGiftCard.gift_card_product;
	if (!GIFT_CARD_VARIANT_ID || GIFT_CARD_VARIANT_ID === '') {
		console.log('[GIFT CARD] Step 4: Gift card variant ID not found');
		return;
	}
	console.log('[GIFT CARD] Step 4: Gift card variant ID:', GIFT_CARD_VARIANT_ID);

	const CONFIG_THRESHOLD = parseFloat(window.configGiftCard.threshold) || 0;
	console.log('[GIFT CARD] Step 5: Threshold from config:', CONFIG_THRESHOLD);

	let isProcessing = false;

	function getCartElement() {
		return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
	}

	function getThreshold() {
		const currencyRate = parseFloat(Shopify.currency.rate || 1);
		const threshold = CONFIG_THRESHOLD * 100 * currencyRate;
		console.log('[GIFT CARD] getThreshold - Config:', CONFIG_THRESHOLD, 'Rate:', currencyRate, 'Final:', threshold);
		return threshold;
	}

	function hasGiftCard(cartItems) {
		if (!cartItems || !Array.isArray(cartItems)) {
			console.log('[GIFT CARD] hasGiftCard - No items or not array');
			return false;
		}
		const hasGift = cartItems.some(item => String(item.variant_id) === String(GIFT_CARD_VARIANT_ID));
		console.log('[GIFT CARD] hasGiftCard - Result:', hasGift, 'Items:', cartItems.length);
		return hasGift;
	}

	async function getCartData() {
		console.log('[GIFT CARD] getCartData - Fetching cart...');
		try {
			const response = await fetch('/cart.js');
			const cartData = await response.json();
			console.log('[GIFT CARD] getCartData - Success. Subtotal:', cartData.items_subtotal_price, 'Items:', cartData.items.length);
			return cartData;
		} catch (error) {
			console.error('[GIFT CARD] getCartData - Error:', error);
			return null;
		}
	}

	async function addGiftCard() {
		console.log('[GIFT CARD] addGiftCard - Starting...');
		if (isProcessing) {
			console.log('[GIFT CARD] addGiftCard - Already processing, skipping');
			return;
		}
		isProcessing = true;

		try {
			const config = fetchConfig('javascript');
			config.headers['X-Requested-With'] = 'XMLHttpRequest';
			delete config.headers['Content-Type'];

			const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
				let sections = [];

				if (cart && cart.getSectionsToRender) {
				sections = cart.getSectionsToRender().map(section => section.section || section.id);
				}

    		console.log("sections",sections);

			const formData = new FormData();
			formData.append('id', GIFT_CARD_VARIANT_ID);
			formData.append('quantity', 1);
			formData.append('sections', sections.join(','));
            formData.append('sections_url', window.location.pathname);

			config.body = formData;

			console.log('[GIFT CARD] addGiftCard - Making request to:', routes.cart_add_url);
			const response = await fetch(`${routes.cart_add_url}`, config);
			const responseData = await response.json();

			console.log('[GIFT CARD] addGiftCard - Response received. Status:', responseData.status);

			if (!responseData.status) {
				console.log('[GIFT CARD] addGiftCard - Product added successfully');

				if (cart && cart.renderContents && responseData.sections) {
					cart.renderContents(responseData);
				}
				
				if (responseData.item_count !== undefined) {
					const cartIconBubble = document.getElementById('cart-icon-bubble');
					if (cartIconBubble) {
						const countElement = cartIconBubble.querySelector('.cart-count-bubble, [class*="count"]');
						if (countElement) {
							countElement.textContent = responseData.item_count;
							console.log('[GIFT CARD] addGiftCard - Updated cart count to:', responseData.item_count);
						}
					}
				}
				
				
				console.log('[GIFT CARD] addGiftCard - COMPLETED SUCCESSFULLY (silent add, no UI updates)');
			} else {
				console.log('[GIFT CARD] addGiftCard - Failed. Status:', responseData.status, 'Error:', responseData.message);
			}
		} catch (error) {
			console.error('[GIFT CARD] addGiftCard - ERROR:', error);
		} finally {
			isProcessing = false;
			console.log('[GIFT CARD] addGiftCard - Processing flag reset');
		}
	}

	async function removeGiftCard() {
		console.log('[GIFT CARD] removeGiftCard - Starting...');
		if (isProcessing) {
			console.log('[GIFT CARD] removeGiftCard - Already processing, skipping');
			return;
		}
		isProcessing = true;

		try {
			const cart = getCartElement();
			const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
			
			console.log('[GIFT CARD] removeGiftCard - Cart element found:', !!cart, 'Cart items found:', !!cartItems);

			const cartData = await getCartData();
			if (!cartData || !cartData.items) {
				console.log('[GIFT CARD] removeGiftCard - Could not get cart data');
				isProcessing = false;
				return;
			}

			const giftCardItem = cartData.items.find(item => String(item.variant_id) === String(GIFT_CARD_VARIANT_ID));
			if (!giftCardItem) {
				console.log('[GIFT CARD] removeGiftCard - Gift card not found in cart');
				isProcessing = false;
				return;
			}

			const line = giftCardItem.key || giftCardItem.id;
			console.log('[GIFT CARD] removeGiftCard - Gift card line:', line);

			let sections = [];
			if (cartItems && cartItems.getSectionsToRender) {
				sections = cartItems.getSectionsToRender().map((section) => section.section);
				console.log('[GIFT CARD] removeGiftCard - Using cart items sections:', sections);
			} else if (cart && cart.getSectionsToRender) {
				sections = cart.getSectionsToRender().map((section) => section.id);
				console.log('[GIFT CARD] removeGiftCard - Using drawer sections:', sections);
			} else {
				sections = ['cart-drawer', 'cart-icon-bubble'];
				console.log('[GIFT CARD] removeGiftCard - Using default sections:', sections);
			}

			const body = JSON.stringify({
				id: GIFT_CARD_VARIANT_ID,
				quantity: 0,
				sections: sections,
				sections_url: window.location.pathname
			});

			console.log('[GIFT CARD] removeGiftCard - Request body prepared');

			const response = await fetch(`${routes.cart_change_url}`, { 
				...fetchConfig(), 
				...{ body } 
			});
			const responseText = await response.text();
			const parsedState = JSON.parse(responseText);

			console.log('[GIFT CARD] removeGiftCard - Response received. Has errors:', !!parsedState.errors, 'Has sections:', !!parsedState.sections);

			if (!parsedState.errors && parsedState.sections) {
				console.log('[GIFT CARD] removeGiftCard - Updating sections...');
				
				if (cart && cart.renderContents) {
					const responseData = {
						sections: {},
						id: GIFT_CARD_VARIANT_ID
					};
					if (cart.getSectionsToRender) {
						cart.getSectionsToRender().forEach((section) => {
							if (parsedState.sections[section.id]) {
								responseData.sections[section.id] = parsedState.sections[section.id];
							} else if (parsedState.sections[section.section]) {
								responseData.sections[section.id] = parsedState.sections[section.section];
							}
						});
					}
					
					if (Object.keys(responseData.sections).length > 0) {
						console.log('[GIFT CARD] removeGiftCard - Using drawer.renderContents');
						cart.renderContents(responseData);
					} else {
						console.log('[GIFT CARD] removeGiftCard - Could not map sections, using manual update');
						if (cartItems && cartItems.getSectionsToRender) {
							cartItems.getSectionsToRender().forEach((section) => {
								const elementToReplace =
									document.getElementById(section.id)?.querySelector(section.selector) ||
									document.getElementById(section.id);
								if (elementToReplace && parsedState.sections[section.section]) {
									const parser = new DOMParser();
									const doc = parser.parseFromString(parsedState.sections[section.section], 'text/html');
									const selector = section.selector || '.shopify-section';
									const newContent = doc.querySelector(selector);
									if (newContent) {
										elementToReplace.innerHTML = newContent.innerHTML;
										console.log('[GIFT CARD] removeGiftCard - Updated section:', section.id);
									}
								}
							});
						}
					}
				} else if (cartItems && cartItems.getSectionsToRender) {
					console.log('[GIFT CARD] removeGiftCard - Using cart items manual update');
					cartItems.getSectionsToRender().forEach((section) => {
						const elementToReplace =
							document.getElementById(section.id)?.querySelector(section.selector) ||
							document.getElementById(section.id);
						if (elementToReplace && parsedState.sections[section.section]) {
							const parser = new DOMParser();
							const doc = parser.parseFromString(parsedState.sections[section.section], 'text/html');
							const selector = section.selector || '.shopify-section';
							const newContent = doc.querySelector(selector);
							if (newContent) {
								elementToReplace.innerHTML = newContent.innerHTML;
								console.log('[GIFT CARD] removeGiftCard - Updated section:', section.id);
							}
						}
					});
				}

				if (cart) {
					cart.classList.toggle('is-empty', parsedState.item_count === 0);
				}
				if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
					console.log('[GIFT CARD] removeGiftCard - Publishing cart update event');
					publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-card-auto-add' });
				}
				console.log('[GIFT CARD] removeGiftCard - COMPLETED SUCCESSFULLY');
			} else {
				console.log('[GIFT CARD] removeGiftCard - Failed. Errors:', parsedState.errors);
			}
		} catch (error) {
			console.error('[GIFT CARD] removeGiftCard - ERROR:', error);
		} finally {
			isProcessing = false;
			console.log('[GIFT CARD] removeGiftCard - Processing flag reset');
		}
	}

	async function checkAndUpdateGiftCard() {
		console.log('[GIFT CARD] checkAndUpdateGiftCard - Starting check...');
		if (isProcessing) {
			console.log('[GIFT CARD] checkAndUpdateGiftCard - Already processing, skipping');
			return;
		}

		try {
			const cartData = await getCartData();
			if (!cartData) {
				console.log('[GIFT CARD] checkAndUpdateGiftCard - No cart data, aborting');
				return;
			}

			const threshold = getThreshold();
			const subtotal = parseFloat(cartData.items_subtotal_price || 0);
			const hasGift = hasGiftCard(cartData.items);

			console.log('[GIFT CARD] checkAndUpdateGiftCard - Analysis:');
			console.log('  - Subtotal:', subtotal);
			console.log('  - Threshold:', threshold);
			console.log('  - Has gift card:', hasGift);
			console.log('  - Should add:', subtotal >= threshold && !hasGift);
			console.log('  - Should remove:', subtotal < threshold && hasGift);
    		console.log('[GIFT CARD] checkAndUpdateGiftCard - Waiting 600ms...');

			await new Promise(resolve => setTimeout(resolve, 600));

			if (subtotal >= threshold && !hasGift) {
				console.log('[GIFT CARD] checkAndUpdateGiftCard - DECISION: ADD gift card');
				await addGiftCard();
			} else if (subtotal < threshold && hasGift) {
				console.log('[GIFT CARD] checkAndUpdateGiftCard - DECISION: REMOVE gift card');
				await removeGiftCard();
			} else {
				console.log('[GIFT CARD] checkAndUpdateGiftCard - DECISION: NO ACTION needed');
			}
		} catch (error) {
			console.error('[GIFT CARD] checkAndUpdateGiftCard - ERROR:', error);
		}
	}

	function waitForDependencies(callback, maxAttempts = 50) {
		let attempts = 0;
		const checkDependencies = () => {
			attempts++;
			const hasRoutes = typeof routes !== 'undefined';
			const hasFetchConfig = typeof fetchConfig !== 'undefined';
			const hasSubscribe = typeof subscribe !== 'undefined';
			
			console.log('[GIFT CARD] waitForDependencies - Attempt', attempts, '- Routes:', hasRoutes, 'fetchConfig:', hasFetchConfig, 'subscribe:', hasSubscribe);
			
			if (hasRoutes && hasFetchConfig && (hasSubscribe || attempts >= maxAttempts)) {
				console.log('[GIFT CARD] waitForDependencies - All dependencies ready!');
				callback();
			} else if (attempts < maxAttempts) {
				setTimeout(checkDependencies, 100);
			} else {
				console.warn('[GIFT CARD] waitForDependencies - Max attempts reached, proceeding anyway');
				callback();
			}
		};
		checkDependencies();
	}

	function init() {
		console.log('[GIFT CARD] init - Starting initialization...');
		waitForDependencies(() => {
			console.log('[GIFT CARD] init - Dependencies ready, setting up...');
			
			setTimeout(() => {
				console.log('[GIFT CARD] init - Running initial check...');
				checkAndUpdateGiftCard();
			}, 1000);

			if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
				console.log('[GIFT CARD] init - Subscribing to cart update events...');
				subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
					console.log('[GIFT CARD] init - Cart update event received. Source:', event.source);
					if (event.source === 'gift-card-auto-add') {
						console.log('[GIFT CARD] init - Event from gift card, skipping to avoid loop');
						return;
					}
					clearTimeout(window.giftCardCheckTimeout);
					console.log('[GIFT CARD] init - Scheduling check in 800ms...');
					window.giftCardCheckTimeout = setTimeout(() => {
						console.log('[GIFT CARD] init - Debounced check executing...');
						checkAndUpdateGiftCard();
					}, 800);
				});
				console.log('[GIFT CARD] init - Successfully subscribed to cart update events');
			} else {
				console.warn('[GIFT CARD] init - subscribe or PUB_SUB_EVENTS not available');
			}
		});
	}
	console.log('[GIFT CARD] Script ready. Document state:', document.readyState);
	if (document.readyState === 'loading') {
		console.log('[GIFT CARD] Waiting for DOMContentLoaded...');
		document.addEventListener('DOMContentLoaded', () => {
			console.log('[GIFT CARD] DOMContentLoaded fired, initializing...');
			init();
		});
	} else {
		console.log('[GIFT CARD] DOM already ready, initializing immediately...');
		init();
	}
})();
